module.exports = __webpack_public_path__ + "img/gamepad.6211a852.svg";